<app-loader [isLoading]="isLoading"></app-loader>
<div class="right-side-slide" [class.active]="isVisible">
    <div class="top">
        <span class="title-small">Previous requests</span>
        <div class="img-container" (click)="onCross()">
            <div class="cross-icon"></div>
        </div>
    </div>
    <div class="all-txns">
        @for(prev of prevReqArr ; track prev){
        <div class="hover-div">
            <div class="header-detail">
                <div class="dt-and-txnsType">
                    <span class="common-inter">{{prev.statusDesc}}</span>
                    <span class="common-inter txn-dt">{{prev.appliedOn | date:'dd MMM yyyy' }}</span>
                </div>
                <div class="amount2">
                    <span class="common-inter"
                        [ngClass]="{'text-rejected':prev.statusId===85,'text-inProgress':prev.statusId===84}">{{prev.amount}}</span>
                </div>
            </div>
        </div>
        }
    </div>
    <div class="btn2">
        <button class="dp-secondary-btn extra-width" (click)="loadMoreData()">Load more requests</button>
    </div>
</div>